import { CommerceInvoice, DriverCost, CompanionCost } from '../pages';
import { RouteObject } from 'react-router-dom';
import { Finance } from '@/pages/Fleet';

export const FinancesRoutes: RouteObject[] = [
  {
    path: 'finances',
    element: <Finance />,
  },
  {
    path: 'finances/driver-cost',
    element: <DriverCost />,
  },
  {
    path: 'finances/commerce-invoice',
    element: <CommerceInvoice />,
  },
  {
    path: 'finances/companion-cost',
    element: <CompanionCost />,
  },
];
